export default "__VITE_ASSET__39P9iSQD__"